import React from 'react';

import { IntlProvider } from "react-intl";
import messages_en from './translations/en.json';
import messages_pl from './translations/pl.json';
import messages_de from './translations/de.json';

import { withCurrentLanguage } from './context';

const messages: Record<string, Record<string, string>> = {
  'en': messages_en,
  'pl': messages_pl,
  // Fallback to English.
  'de': { ...messages_en, ...messages_de },
}

export default function withLocalization(children: any) {
  return withCurrentLanguage(
    locale => (
      <IntlProvider locale={locale} defaultLocale={'pl'} messages={messages[locale]}>
        {children}
      </IntlProvider>
    ));
};
